import { createClient, SupabaseClient } from "@supabase/supabase-js";
import { useSession } from "@clerk/nextjs";
import { useMemo } from "react";

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!;

// Basic client for non-authenticated operations (use sparingly)
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Hook to get authenticated Supabase client with Clerk session token (2025 native integration)
export const useSupabaseClient = (): SupabaseClient => {
  const { session } = useSession();

  return useMemo(() => {
    return createClient(supabaseUrl, supabaseAnonKey, {
      accessToken: async () => {
        return session?.getToken() ?? null;
      },
    });
  }, [session]);
};
